import { z } from 'zod'

import type { Profession } from 'src/shared/features/users/schemas/profession'

export interface CreatePostData {
  text: string
  images: string[]
}

export interface StreamPost {
  id: string
  object: string
  images: string[]
  time: string
  actor: {
    id: string
    username: string
    fullName: string
    profilePhoto: string | null
    profession: Profession | null
    shortAddress: string | null
    createdAt: string
    updatedAt: string
  }
  foreignId: string
  text: string
  duration?: number
  origin?: string
  reactionCounts?: {
    like?: number
    comment?: number
  }
  ownReactions?: {
    like?: Array<{
      id: string
      createdAt: string
    }>
  }
  latestReactions?: Reaction[]
}

export interface UpdatePostData {
  id: string
  text: string
  images: string[]
}

export interface GetTimelineOptions {
  offset?: number
  limit?: number
}

export interface TimelineResponse {
  results: StreamPost[]
  duration: string
  offset: number
  limit: number
  hasNext: boolean
  nextOffset: number | null
}

export interface Reaction {
  id: string
  userId: string
  user?: {
    id: number
    username: string
    fullName: string
    profilePhoto: string | null
    profession: Profession | null
    shortAddress: string | null
  }
  activityId: string
  //TODO: consolidate this parent id typing
  parent?: string
  parentId?: string
  kind: string
  data: {
    text: string
    images?: string[]
  }
  createdAt: string
  updatedAt: string
  hasLiked?: boolean
  ownLike?: string
  childrenCounts?: {
    like?: number
    comment?: number
  }
  latestChildren?: {
    comment?: Reaction[]
  }
}

export const PostSchema = z.object({
  text: z.string().max(1000, 'Post cannot exceed 1000 characters'),
})

export const CommentSchema = z.object({
  text: z.string().max(1000, 'Comment cannot exceed 1000 characters'),
})

export type PostInput = z.infer<typeof PostSchema>
export type CommentInput = z.infer<typeof CommentSchema>
